import { useTranslation } from 'react-i18next';

export const ServiceVariableTooltipPwd = () => {
  const { t: translate } = useTranslation();
  return (
    <>
      {String(translate('service_details_form_component.service_variable_tooltip_title_pwd'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_format_pwd'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_example_pwd'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_azure_pwd'))}
    </>
  );
};
